// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__34h97","form":"styles_form__1pTGJ"};